import { hasOwnProperty, isEmptyObject, isObject, isDate, isHTMLElement } from './helpers';

export const ObjectDeepDiff: (lhs: object, rhs: object) => object = (lhs: object, rhs: object) => {
  if (lhs === rhs) return {}; // equal return no diff

  if (!isObject(lhs) || !isObject(rhs) || isHTMLElement(lhs) || isHTMLElement(rhs)) return rhs; // return updated rhs

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const l: Record<string, any> = lhs;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const r: Record<string, any> = rhs;

  const deletedValues: object = Object.keys(l).reduce<object>((acc, key) => {
    if (!hasOwnProperty(r, key)) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      acc[key] = undefined;
    }
    return acc;
  }, {});

  if (isDate(l) || isDate(r)) {
    if (l.valueOf() == r.valueOf()) return {};
    return r;
  }

  return Object.keys(r).reduce<object>((acc, key) => {
    if (!hasOwnProperty(l, key)) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      acc[key] = r[key]; // return added r key
      return acc;
    }

    const difference: object = ObjectDeepDiff(l[key], r[key]);

    // If the difference is empty, and the lhs is an empty object or the rhs is not an empty object
    if (
      isEmptyObject(difference) &&
      !isDate(difference) &&
      (isEmptyObject(l[key]) || !isEmptyObject(r[key]))
    )
      return acc; // return no diff
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    acc[key] = difference; // return updated key
    return acc; // return updated key
  }, deletedValues);
};
